var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 18",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 8.167V4.833a3.333 3.333 0 016.667 0v3.334M1.167 9.833a1.667 1.667 0 011.667-1.666h8.333a1.667 1.667 0 011.667 1.666v5a1.666 1.666 0 01-1.667 1.667H2.834a1.667 1.667 0 01-1.667-1.667v-5zm5 2.5a.833.833 0 101.667 0 .833.833 0 00-1.667 0z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLock;